/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_1_LabelInputs */

const en_services_svc_money_art_1_label = /** @type {(inputs: Services_Svc_Money_Art_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company found`)
};

const lv_services_svc_money_art_1_label = /** @type {(inputs: Services_Svc_Money_Art_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzņēmums atrasts`)
};

/**
* | output |
* | --- |
* | "Company found" |
*
* @param {Services_Svc_Money_Art_1_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_1_label = /** @type {((inputs?: Services_Svc_Money_Art_1_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_1_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_1_label(inputs)
	return en_services_svc_money_art_1_label(inputs)
});